// extracted by mini-css-extract-plugin
export default {"operationGroup":"StudyBrowserAatDetail_operationGroup__y5nR8","operationGroupItem":"StudyBrowserAatDetail_operationGroupItem__g+xS6"};